import { LitElement, css, html } from 'lit';

export class AppSkeletonLoader extends LitElement {
    static properties = {
        name: {},
    };
    // Define scoped styles right with your component, in plain CSS
    static styles = css`
        :host {
            background-color: #fafafa;
        }
        .App-bannerContainer {
            background-color: #fafafa;
            background-image: url(/images/background-optimized.svg);
            background-repeat: no-repeat;
            background-size: cover;
            justify-content: space-between;
            height: 216px;
            margin-top: -1px;
            margin-left: -1px;
            padding: 0 16px;
            display: flex;
        }
        .App-wrap,
        .App-bannerContainer {
            padding: 0 36px;
        }

        .App-wrap {
            margin-top: -120px;
        }

        .App-appTitle {
            color: #fff;
            margin-top: 24px;
            font-size: 2.25rem;
            font-weight: bold;
            line-height: 1.33;
            display: inline-block;
        }
        .css-snkuhx {
            background-color: #f4f4f6;
            padding: 8px;
            margin-bottom: 8px;
            width: -webkit-fit-content;
            width: -moz-fit-content;
            width: fit-content;
            border-radius: 4px;
        }
        .css-pl8gqh-MuiStack-root {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-flex-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
        }
        .css-1rmwe59 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-align-items: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-right: 1px;
            background-color: #fff;
            width: 100px;
            height: 30px;
            border-radius: 4px;
        }
        .css-1rgcig8 {
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-align-items: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-right: 1px;
            width: 100px;
            height: 30px;
            border-radius: 4px;
        }
        .content-container {
            background-color: #fff;
            height: 60vh;
        }
    `;

    constructor() {
        super();
        // Declare reactive properties
        this.name = 'App Skeleton Loader';
    }

    // Render the UI as a function of component state
    render() {
        return html` <section class="App-skeletonLoader">
            <div class="App-bannerContainer" data-testid="appBanner">
                <label class="App-appTitle">User &amp; Application Settings</label>
            </div>
            <div class="App-wrap" data-testid="appWrap">
                <div class="tabs-container css-snkuhx">
                    <div class="MuiStack-root css-pl8gqh-MuiStack-root">
                        <div class="active-tab css-1rmwe59">
                            <div class="item-text css-ii5yhd"></div>
                        </div>
                        <div class="non-active-tab css-1rgcig8">
                            <div class="item-text css-ii5yhd"></div>
                        </div>
                        <div class="non-active-tab css-1rgcig8">
                            <div class="item-text css-ii5yhd"></div>
                        </div>
                        <div class="non-active-tab css-1rgcig8">
                            <div class="item-text css-ii5yhd"></div>
                        </div>
                        <div class="non-active-tab css-1rgcig8">
                            <div class="item-text css-ii5yhd"></div>
                        </div>
                        <div class="non-active-tab css-1rgcig8">
                            <div class="item-text css-ii5yhd"></div>
                        </div>
                    </div>
                </div>
                <div class="content-container"></div>
            </div>
        </section>`;
    }
}

customElements.define('app-skeleton-loader', AppSkeletonLoader);
